import { Reveal, Eyebrow } from "./Reveal";
import { BadgeCheck, Users, HardHat } from "lucide-react";
import { useLang } from "../i18n";

export const Team = () => {
  const { t } = useLang();

  const HIGHLIGHTS = [
    { icon: BadgeCheck, label: t("Oltre 20 anni di esperienza", "Over 20 years of experience") },
    { icon: HardHat, label: t("Capo cantiere, in prima linea", "Site manager, on the front line") },
    { icon: Users, label: t("Alla guida di un team qualificato", "Leading a qualified team") },
  ];

  return (
    <section id="team" data-testid="team-section" className="relative py-24 sm:py-32 bg-[#0A1220] overflow-hidden">
      <div className="absolute inset-0 blueprint-dots opacity-[0.04] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-12 items-center">
        <div className="lg:col-span-5">
          <Reveal>
            <div className="relative max-w-md mx-auto lg:mx-0">
              <div className="absolute -inset-3 border border-[#D4AF37]/30 rounded-2xl translate-x-4 translate-y-4 pointer-events-none" />
              <div className="relative overflow-hidden rounded-2xl border border-[#D4AF37]/25 shadow-[0_30px_80px_rgba(0,0,0,0.5)]">
                <img
                  src="/team/adrian-turlica.jpg"
                  alt={t("Adrian Turlica, titolare di Adriatica S.r.l. Semplificata", "Adrian Turlica, owner of Adriatica S.r.l. Semplificata")}
                  className="w-full h-[480px] sm:h-[540px] object-cover object-top"
                  data-testid="team-photo"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#070D18]/70 via-transparent to-transparent" />
                <div className="absolute bottom-0 inset-x-0 p-6">
                  <p className="font-display text-xl text-white tracking-wide">Adrian Turlica</p>
                  <p className="text-sm text-[#F3E08B] mt-1">{t("Fondatore e capo cantiere", "Founder & Site Manager")}</p>
                </div>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal>
            <Eyebrow>{t("Il nostro team", "Our team")}</Eyebrow>
            <h2 className="mt-5 font-display font-semibold text-white text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
              {t("Chi guida", "Who leads")} <span className="text-gold-gradient">Adriatica</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-base sm:text-lg text-slate-300 leading-relaxed">
              {t(
                "Adrian Turlica è il fondatore di Adriatica S.r.l. Semplificata. Con oltre vent'anni di esperienza nel settore edile, ha trasformato la passione per la costruzione in un'azienda che unisce artigianalità, metodo e attenzione alle persone.",
                "Adrian Turlica is the founder of Adriatica S.r.l. Semplificata. With over twenty years of experience in construction, he has turned a passion for building into a company that combines craftsmanship, method and care for people."
              )}
            </p>
            <p className="mt-4 text-base sm:text-lg text-slate-400 leading-relaxed">
              {t(
                "In cantiere ci mette la faccia ogni giorno come capo cantiere, alla guida di un team tecnico qualificato che segue ogni progetto con la stessa cura, dal primo sopralluogo alla consegna. La sua filosofia è semplice — fare le cose bene, rispettare la parola data e consegnare lavori di cui andare orgogliosi.",
                "He's on site every day as site manager, leading a qualified technical team that follows every project with the same care, from the first site visit to delivery. His philosophy is simple — do things well, keep your word, and deliver work to be proud of."
              )}
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-8 flex flex-wrap gap-3" data-testid="team-highlights">
              {HIGHLIGHTS.map((h) => (
                <span
                  key={h.label}
                  className="inline-flex items-center gap-2 text-sm text-[#F3E08B] border border-[#D4AF37]/35 rounded-full px-4 py-2 bg-[#D4AF37]/5"
                >
                  <h.icon size={14} className="text-[#D4AF37]" />
                  {h.label}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
